import { PrimaryControls } from '@/features/inventory/admin/components/PrimaryControls'
import { TableControls } from '@/features/inventory/admin/components/TableControls'
import { Icon } from '@/components/Icon'
import styles from './InventoryViewerHeader.module.css'

export interface InventoryViewerHeaderProps {
  searchText: string
  onSearchTextChange: (text: string) => void
  isGlobalInventory: boolean
  onAddInventoryItem: () => void
}

export function InventoryViewerHeader({
  searchText,
  onSearchTextChange,
  isGlobalInventory,
  onAddInventoryItem,
}: InventoryViewerHeaderProps) {
  return (
    <div className={styles.root}>
      <PrimaryControls
        onChange={onSearchTextChange}
        value={searchText}
        actions={
          <TableControls
            isGlobalInventory={isGlobalInventory}
            onAddInventoryItem={onAddInventoryItem}
            button={
              <div>
                <Icon name="more" />
              </div>
            }
          />
        }
        testId="job-search-field"
      />
    </div>
  )
}
